import { TenantEntity } from '../TenantEntity'

export class IataPrice extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get carrier() {
    return this._data.carrier
  }
  set carrier(carrier) {
    this._data.carrier = carrier
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType
  }
  get levelM() {
    return this._data.levelM
  }
  set levelM(levelM) {
    this._data.levelM = levelM || 0
  }
  get levelN() {
    return this._data.levelN
  }
  set levelN(levelN) {
    this._data.levelN = levelN || 0
  }
  get level45() {
    return this._data.level45
  }
  set level45(level45) {
    this._data.level45 = level45 || 0
  }
  get level100() {
    return this._data.level100
  }
  set level100(level100) {
    this._data.level100 = level100 || 0
  }
  get level300() {
    return this._data.level300
  }
  set level300(level300) {
    this._data.level300 = level300 || 0
  }
  get level500() {
    return this._data.level500
  }
  set level500(level500) {
    this._data.level500 = level500 || 0
  }
  get level1000() {
    return this._data.level1000
  }
  set level1000(level1000) {
    this._data.level1000 = level1000 || 0
  }
  get level2000() {
    return this._data.level2000
  }
  set level2000(level2000) {
    this._data.level2000 = level2000 || 0
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  getPriceRange(cWeight) {
    let v = 0
    if (cWeight > 0 && cWeight < 45) {
      v = isNaN(this._data.levelN) ? 0 : this._data.levelN
    } else if (cWeight >= 45 && cWeight < 100) {
      v = isNaN(this._data.level45) ? 0 : this._data.level45
    } else if (cWeight >= 100 && cWeight < 300) {
      v = isNaN(this._data.level100) ? 0 : this._data.level100
    } else if (cWeight >= 300 && cWeight < 500) {
      v = isNaN(this._data.level300) ? 0 : this._data.level300
    } else if (cWeight >= 500 && cWeight < 1000) {
      v = isNaN(this._data.level500) ? 0 : this._data.level500
    } else if (cWeight >= 1000) {
      v = isNaN(this._data.level1000) ? 0 : this._data.level1000
    }
    return v
  }
}
